export default "__VITE_ASSET__DR3g86OI__"